<template>
  <div class="future-loader">
    <ContentLoader v-if="loaderType === 'normal'" width="200" height="120">
      <rect x="0" y="5"  width="50" height="8" />
      <rect x="0" y="20"  width="200" height="74" />
      <rect x="0" y="98"  width="80" height="8" />
      <rect x="0" y="110"  width="100" height="5" />
      <rect x="120" y="107"  width="80" height="8" />
    </ContentLoader>
    <ContentLoader v-if="loaderType === 'homeCase'" width="200" height="120">
      <rect x="0" y="5"  width="50" height="8" />
      <rect x="0" y="20"  width="200" height="74" />
      <rect x="0" y="98"  width="80" height="8" />
      <rect x="0" y="110"  width="100" height="5" />
      <rect x="120" y="107"  width="80" height="8" />
    </ContentLoader>
    <ContentLoader v-if="loaderType === 'homeNews'" width="1600" height="811">
      <rect x="0" y="0"  width="228" height="49" />
      <rect x="0" y="78"  width="949" height="34" />
      <rect x="0" y="160"  width="500" height="335" />
      <rect x="550" y="160"  width="500" height="335" />
      <rect x="1100" y="160"  width="500" height="335" />
      <rect x="0" y="530"  width="501" height="34" />
      <rect x="0" y="650"  width="184" height="34" />
    </ContentLoader>
    <ContentLoader v-if="loaderType === 'aboutCase'" width="1600" height="811">
      <rect x="0" y="0"  width="785" height="319" />
      <rect x="0" y="362"  width="501" height="34" />
      <rect x="0" y="431"  width="785" height="34" />

      <rect x="815" y="0"  width="785" height="319" />
      <rect x="815" y="362"  width="501" height="34" />
      <rect x="815" y="431"  width="785" height="34" />
    </ContentLoader>
    <ContentLoader v-if="loaderType === 'normalList'" width="1920" height="1000">
      <rect x="162" y="100"  width="500" height="355" />
      <rect x="162" y="470"  width="501" height="34" />
      <rect x="162" y="570"  width="184" height="34" />

      <rect x="712" y="100"  width="500" height="355" />
      <rect x="712" y="470"  width="501" height="34" />
      <rect x="712" y="570"  width="184" height="34" />

      <rect x="1262" y="100"  width="500" height="355" />
      <rect x="1262" y="470"  width="501" height="34" />
      <rect x="1262" y="570"  width="184" height="34" />
    </ContentLoader>
  </div>
</template>

<script>
  import { ContentLoader } from 'vue-content-loader'
  export default {
    name:"Loader",
    props:{
      loaderType:{
        type:String,
        default:'normal',
      }
    },
    components:{
      ContentLoader
    },
  }
</script>

<style lang="less" scoped>
  .future-loader{
    height: 100%;
    display: flex;
    align-items: center;
    svg{
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/loading/loader.vue